import { CapoPlugin } from "/home/runner/work/solo-brands-scaffolding/solo-brands-scaffolding/webapp/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];